import { SyntheticEvent } from 'react'
import { CookieManagerService } from '../services'
import { ABConfigResponseTransport } from '../transports/ab-config-transport'
import { isServer } from './platform-utils'

export const appendClassName = (element: HTMLElement, className: string) => {
    if (element) {
        element.classList.add(className)
    }
}

export const removeClassName = (element: HTMLElement, className: string) => {
    if (element) {
        element.classList.remove(className)
    }
}

export function getSafeDisableProps(shouldDisable: boolean, customProp?: string) {
    return shouldDisable ? { [customProp ? customProp : 'disabled']: true } : {}
}

export function setABConfig(model: ABConfigResponseTransport | null): void {
    if (!isServer && model) {
        const abString = Object.entries(model)
            .map(([key, value]) => `${key}:${value.experimentVersion}:${value.activeVariant}`)
            .join('|')

        ;(globalThis as any)._abConfig = abString
        CookieManagerService.setCookie(CookieManagerService.AB_CONFIG, abString, {
            path: '/',
            secure: globalThis.location.protocol === 'https:',
            sameSite: 'None',
            raw: true,
        })
    }
}

export const stopPropagation = (e: SyntheticEvent) => {
    e.stopPropagation()
}

export const scrollToTop = (behavior: ScrollBehavior = 'smooth') => {
    if (!isServer) {
        window.scrollTo({
            top: 0,
            behavior,
        })
    }
}
